import React from 'react';
import DestinationTemplate from '../../components/DestinationTemplate';

const BhutanPage = () => {
  return <DestinationTemplate destinationId="bhutan" />;
};

export default BhutanPage;
